// extracted by mini-css-extract-plugin
module.exports = {"body":"accessDeniedError_body__y3oeK","mainText":"accessDeniedError_mainText__2xVh5","subText":"accessDeniedError_subText__cn8kn","error":"accessDeniedError_error__19ROf"};